<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <v-form ref="form" v-model="valid">
          <v-text-field v-model="delivery.from_name" label="Naziv radnje" required ref="from" :readonly="readonly"></v-text-field>
          <addresss v-model="delivery.from_address" label="Adresa radnje" :suggestions="streets" :readonly="readonly"></addresss>
          <v-text-field v-model="delivery.recipient_phone" label="Telefon primaoca" type="tel" ref="to" @input="autocompleteRecipient"></v-text-field>
          <v-text-field v-model="delivery.to_name" label="Ime primaoca" required></v-text-field>
          <addresss v-model="delivery.to_address" label="Adresa primaoca" :suggestions="streets"></addresss>
          <timepicker v-model="delivery.time_targeted_pickup" label="Vreme preuzimanja" templates="15,30,45"></timepicker>
          <timepicker v-model="delivery.time_targeted_delivery" label="Vreme dostave" templates="30,45,60,90"></timepicker>
          <v-textarea class="mt-2" v-model="delivery.description" label="Napomene" outline rows="2" auto-grow></v-textarea>
          <v-btn class="primary mt-0 mb-5" large block @click="submit" :loading="loading">sačuvaj</v-btn>
          <v-alert v-model="error" type="error">Došlo je do greške, pokušajte ponovo ili kontaktirajte podršku</v-alert>
          <v-btn class="secondary" bottom large block @click="$router.back()">nazad</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import auth from '@/services/authService.js'
import deliveryService from '@/services/deliveryService'
import lookupService from '@/services/lookupService'
import timepicker from '@/components/Timepicker'
import address from '@/components/Address'

let recipients = {}
if (localStorage.getItem('recipients')) {
  try {
    recipients = JSON.parse(localStorage.getItem('recipients'))
  } catch (e) {
    localStorage.removeItem('recipients')
  }
}

export default {
  data () {
    return {
      delivery: {},
      streets: lookupService.getStreets(),
      loading: false,
      error: false,
      valid: false,
      readonly: true
    }
  },
  created () {
    if (this.$route.params && this.$route.params.id) {
      deliveryService.getDelivery(this.$route.params.id).then((delivery) => {
        this.delivery = delivery
      })
    } else {
      auth.getUser().then(user => {
        this.readonly = user.roles.indexOf('proxy') === -1 || user.roles.indexOf('store') === -1
        Vue.set(this.delivery, 'from_name', user.name)
        Vue.set(this.delivery, 'from_address', user.address)
        this.$nextTick(() => this.$refs.to.focus())
      })
    }
  },
  methods: {
    autocompleteRecipient (phone) {
      let recipient = recipients[phone]
      if (recipient) {
        this.delivery.to_address = recipient.address
        this.delivery.to_name = recipient.name
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        recipients[this.delivery.recipient_phone] = {
          name: this.delivery.to_name,
          address: this.delivery.to_address
        }
        localStorage.setItem('recipients', JSON.stringify(recipients))
        deliveryService.postDelivery(this.delivery).then((response) => {
          this.loading = false
          this.$router.push('/')
        }, (error) => {
          console.log(error)
          this.loading = false
          this.error = true
        })
      }
    }
  },
  components: {
    'timepicker': timepicker,
    'addresss': address
  }
}
</script>
